export const isAttributeFormatDescription = (description: string): boolean => {
  const attributeRegex = /^(\s*[a-zA-Z0-9]+\s*:\s*[a-zA-Z0-9\s]+;\s*)*$/;

  return attributeRegex.test(description);
};
